import { Clock } from "lucide-react";

import { useQuoteCountdown } from "@/shared/hooks/useQuoteCountdown";
import useTranslations from "@/shared/lang/useTranslations";
import { cn } from "@/shared/lib/utils";

/**
 * How long a converted price holds. Its own component so the one-second tick re-renders only this line, and
 * nothing once it lapses: the panel re-prices an expired quote on its own.
 */
export function QuoteValidity({ expiresAt, className }: { expiresAt: string; className?: string }) {
  const { t } = useTranslations("dispersions");
  const { formattedTime, timeRemaining } = useQuoteCountdown(expiresAt);
  if (timeRemaining <= 0) return null;
  return (
    <span
      className={cn(
        "flex items-center gap-1 font-mono text-xs tabular-nums",
        timeRemaining <= 60_000 ? "text-warning" : "text-muted-foreground",
        className,
      )}
    >
      <Clock className="size-3.5 shrink-0" aria-hidden="true" />
      {t("send_rate_valid_for", { time: formattedTime })}
    </span>
  );
}
